import "./auth-service-tools177.js";
import { createContext, useContext } from "react";
const DirectionContext = /*#__PURE__*/createContext({
  dir: "ltr",
  toggleDirection: () => {},
  setDirection: () => {}
});

function useDirection() {
  return useContext(DirectionContext);
}

export { DirectionContext, useDirection };